module.exports = __webpack_public_path__ + "static/media/img_connect02.ec1df4a7.jpg";